import React from "react";

import { IProject } from "../../store/feedStoreTypes";
import { ActionContainer } from "./style";
import DetailItemDownload from "./DetailItemDownload";
import DetailItemVideo from "./DetailItemVideo";
import DetailItemInfo from "./DetailItemInfo";
import DetailItemFab from "./DetailItemFab";
import DetailPlaceholder from "./DetailPlaceholder";

interface Props {
  id: string;
  isAr: boolean;
  project: null | IProject;
  setLikeCount: (_: number) => void;
}

const DetailItemView = ({ id, isAr, project, setLikeCount }: Props) => {
  // 해당 아이템의 projectId와 현재 active Id가 동일하지 않으면 placeholder 노출
  if (!project || project.projectId !== id) {
    return <DetailPlaceholder isAr={isAr} />;
  }
  const {
    ratio,
    duration,
    videoPath,
    projectId,
    likeCounts,
    downloadCounts,
    translation: { title, description },
    share: { dynamicLink },
  } = project;

  return (
    <React.Fragment>
      <DetailItemVideo
        id={projectId}
        duration={duration}
        videoPath={videoPath}
      />
      <ActionContainer style={{ flexDirection: isAr ? "row-reverse" : "row" }}>
        <DetailItemInfo
          {...{
            ratio,
            duration,
            title,
            description,
            projectId,
            downloadCounts,
          }}
        />
        <DetailItemFab
          {...{ projectId, dynamicLink, likeCounts, title }}
          setLikeCount={setLikeCount}
        />
        <DetailItemDownload project={project} />
      </ActionContainer>
    </React.Fragment>
  );
};

export default DetailItemView;
